<template>
    <div class="container-supervisor-or-manager-delete">
        <p>Selecione um <strong>{{typeGroup(user.group)}}</strong> para receber os dados do usuário(a) <strong>{{user.name}}</strong> </p>
        <p>O usuário selecionado passará a fazer parte das filas de distribuição de leads e oferta ativa, caso o usuário(a) <strong>{{user.name}}</strong> faça parte de alguma dessas filas.</p>
        <ui-select-v2
            v-model="selectNewTeam"
            label="Equipe:"
            item-label="label"
            return-value="value"
            :data="dataTeams"
            :loading="loadTeams"
            open-event="change-profile-teams"
            search-event="change-profile-teams"
            ajax-search
            @input='leave'
        />
        <ui-select-v2 
            v-if="userTransferData && !managerNotFound"
            :label="typeGroup(user.group) + ':'"
            item-label="label"
            return-value="object"
            :data="userTransferData"
            @input='setLeave'
        />
        <div v-if="load" class="load">
            <ui-load-indicator
                bg-color="#e7e9f4"
                color="#69D296"
                :h="30"
                :stroke="5" />
        </div>
        <div v-if="managerNotFound" class="not-found">
            <p> <i aria-hidden="true"  class="fad fa-user-times"/> Não encontramos nenhum usuário para receber os dados.</p>
        </div>
    </div>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui';
import { uiSelectV2 } from '@/components/ui/form';
import { team } from '@/services/axios';
export default {
    name: 'ui-supervisor-or-manager-delete',
    components: {
        uiSelectV2,
        uiLoadIndicator
    },
    props: {
        user: {
            type: [String, Object],
            default: ''
        },
        dataTeams: {
            type: Array,
            default: () => []
        },
        loadTeams: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            selectNewTeam: '',
            userTransferData: null,
            load: false,
            managerNotFound: false
        }
    },

    methods: {
        typeGroup(group) {
            var groupUser = ''
            switch (group) {
                case 'manager':
                   groupUser = 'Gerente'
                   break
                case 'supervisor':
                   groupUser = 'Supervisor'
                   break
            }
            return groupUser
        },
        leave(value) {
            this.load = true
            this.userTransferData = null
            let url = this.user.group == 'supervisor' ? team.getSupervisorByTeam(value) : team.getManagersByTeam(value)
            url.then(res => {
                if(res.data.length == 0) {
                    this.managerNotFound = true
                    return this.load = false
                }
               this.userTransferData = res.data.map(val => {
                   return {label: val.first_name, userId: val.id, newManagerId: val.manager_id}
                })
                .filter(res => res.id != this.user.id)
                this.managerNotFound = this.userTransferData.length == 0
                this.load= false
            }).catch (() => {
                this.load = false
                this.managerNotFound = true
            })
        },
        setLeave(transferData) {
            const isManager = this.user.group === 'manager'
            //const isSupervisor = this.user.group === 'supervisor'

            if(!transferData) {
                return this.$emit('desactive','remove', true)
            };
            this.$emit('desactive', 'remove', false)
            
            this.$emit('input', transferData.userId, isManager ? transferData.newManagerId : null, this.selectNewTeam)
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>
